module.exports = __webpack_public_path__ + "static/media/product4.bbe14014.jpg";